<header class="topbar">

  <div>

    <span class="topbar-label">
      Gerenciamento
    </span>

    <h1>
      Acomodações
    </h1>

    <p>
      Gerencie os dados e a disponibilidade dos quartos.
    </p>

  </div>

</header>


<section class="quartos-section">


  <div
    class="loading"
    *ngIf="carregando"
  >
    Carregando acomodações...
  </div>


  <div
    class="quartos-grid"
    *ngIf="!carregando && quartos.length > 0"
  >

    <div
      class="quarto-card"
      *ngFor="let quarto of quartos"
    >

      <div class="quarto-topo">

        <div>

          <h3>
            {{ quarto.nome }}
          </h3>

        </div>


        <span
          class="status"

          [class.disponivel]="
            quarto.status === 'DISPONIVEL'
          "

          [class.indisponivel]="
            quarto.status !== 'DISPONIVEL'
          "
        >

          {{ quarto.status }}

        </span>

      </div>


      <div class="quarto-dados">

        <div>

          <span>
            Capacidade
          </span>

          <strong>
            {{ quarto.capacidade }} hóspedes
          </strong>

        </div>


        <div>

          <span>
            Tarifas
          </span>

          <strong>
            {{ quarto.capacidade }}
            faixa{{ quarto.capacidade > 1 ? 's' : '' }}
          </strong>

        </div>


        <div>

          <span>
            Criança
          </span>

          <strong>
            R$ {{ quarto.valorCrianca | number:'1.2-2' }}
          </strong>

        </div>


        <div>

          <span>
            Animal
          </span>

          <strong>
            R$ {{ quarto.valorAnimal | number:'1.2-2' }}
          </strong>

        </div>

      </div>


      <div class="quarto-acoes">

        <button
          type="button"

          class="btn-editar"

          (click)="
            abrirModalEdicao(quarto)
          "
        >

          Editar dados

        </button>


        <button
          type="button"

          class="btn-status"

          (click)="
            alternarStatus(quarto)
          "
        >

          {{
            quarto.status === 'DISPONIVEL'
              ? 'Desativar'
              : 'Ativar'
          }}

        </button>

      </div>

    </div>

  </div>


  <div
    class="loading"

    *ngIf="
      !carregando &&
      quartos.length === 0
    "
  >

    Nenhuma acomodação encontrada.

  </div>


</section>


<!-- MODAL -->

<div
  class="modal-overlay"

  *ngIf="modalAberto"

  (click)="fecharModal()"
>


  <div
    class="modal"

    (click)="$event.stopPropagation()"
  >


    <div class="modal-header">

      <div>

        <span class="section-label">
          Acomodação
        </span>

        <h2>
          Editar quarto
        </h2>

      </div>


      <button
        type="button"

        class="modal-fechar"

        (click)="fecharModal()"
      >

        ×

      </button>

    </div>


    <form
      class="modal-form"

      (ngSubmit)="salvarQuarto()"
    >


      <!-- NOME -->

      <div class="campo">

        <label for="nome">
          Nome
        </label>

        <input
          id="nome"

          type="text"

          name="nome"

          [(ngModel)]="
            quartoEditando.nome
          "

          [disabled]="salvando"
        >

      </div>


      <!-- DESCRIÇÃO -->

      <div class="campo">

        <label for="descricao">
          Descrição
        </label>

        <textarea
          id="descricao"

          name="descricao"

          rows="3"

          [(ngModel)]="
            quartoEditando.descricao
          "

          [disabled]="salvando"
        ></textarea>

      </div>


      <!-- CAPACIDADE -->

      <div class="campo">

        <label for="capacidade">
          Capacidade
        </label>

        <input
          id="capacidade"

          type="number"

          name="capacidade"

          min="1"

          [(ngModel)]="
            quartoEditando.capacidade
          "

          (ngModelChange)="
            inicializarTarifas()
          "

          [disabled]="salvando"
        >

      </div>


      <!-- VALORES ADICIONAIS -->

      <div class="adicionais-container">


        <div class="tarifas-header">

          <div>

            <span class="section-label">
              Valores adicionais
            </span>

            <h3>
              Crianças e animais
            </h3>

            <p>
              Defina o valor adicional cobrado
              por criança e por animal em cada diária.
            </p>

          </div>

        </div>


        <div class="adicionais-grid">


          <!-- CRIANÇA -->

          <div class="campo">

            <label for="valorCrianca">
              Valor por criança
            </label>

            <div class="tarifa-input">

              <span>
                R$
              </span>

              <input
                id="valorCrianca"

                type="number"

                name="valorCrianca"

                min="0"

                step="0.01"

                [(ngModel)]="
                  quartoEditando.valorCrianca
                "

                [disabled]="salvando"
              >

            </div>

          </div>


          <!-- ANIMAL -->

          <div class="campo">

            <label for="valorAnimal">
              Valor por animal
            </label>

            <div class="tarifa-input">

              <span>
                R$
              </span>

              <input
                id="valorAnimal"

                type="number"

                name="valorAnimal"

                min="0"

                step="0.01"

                [(ngModel)]="
                  quartoEditando.valorAnimal
                "

                [disabled]="salvando"
              >

            </div>

          </div>


        </div>

      </div>


      <!-- TARIFAS -->

      <div class="tarifas-container">


        <div class="tarifas-header">

          <div>

            <span class="section-label">
              Valores das diárias
            </span>

            <h3>
              Tarifas por dia e hóspedes
            </h3>

            <p>
              Defina o valor da diária de acordo
              com o dia da semana e a quantidade
              de hóspedes.
            </p>

          </div>

        </div>


        <div class="tarifas-tabela">


          <!-- CABEÇALHO -->

          <div class="tarifas-linha tarifas-cabecalho">


            <div class="tarifa-dia">
              Dia
            </div>


            <div
              class="tarifa-coluna"

              *ngFor="
                let quantidade of [].constructor(
                  quartoEditando.capacidade
                );

                let i = index
              "
            >

              {{ i + 1 }}

              hóspede{{ i > 0 ? 's' : '' }}

            </div>


          </div>


          <!-- DIAS -->

          <div
            class="tarifas-linha"

            *ngFor="
              let dia of diasSemana
            "
          >


            <div class="tarifa-dia">

              {{ dia.nome }}

            </div>


            <div
              class="tarifa-coluna"

              *ngFor="
                let quantidade of [].constructor(
                  quartoEditando.capacidade
                );

                let i = index
              "
            >

              <div class="tarifa-input">


                <span>
                  R$
                </span>


                <input
                  type="number"

                  min="0"

                  step="0.01"

                  [name]="
                    'tarifa_' +
                    dia.chave +
                    '_' +
                    (i + 1)
                  "

                  [(ngModel)]="
                    quartoEditando
                      .tarifas[dia.chave][i + 1]
                  "

                  [disabled]="salvando"

                >

              </div>

            </div>


          </div>


        </div>


      </div>


      <!-- AÇÕES -->

      <div class="modal-acoes">


        <button
          type="button"

          class="btn-cancelar"

          (click)="fecharModal()"

          [disabled]="salvando"
        >

          Cancelar

        </button>


        <button
          type="submit"

          class="btn-salvar"

          [disabled]="salvando"
        >

          {{
            salvando
              ? 'Salvando...'
              : 'Salvar alterações'
          }}

        </button>


      </div>


    </form>


  </div>

</div>
